import { call, put, select, takeLatest } from 'redux-saga/effects'

import { DRAWABLE_TYPES, PAPER_ELEMENT_TYPE } from '../../../shared/constants/drawable-types'
import managers from '../../lib/managers'
import PaperManager from '../../lib/managers/PaperManager'
import { Workspace } from '../../lib/toolBoxes/2D'
import { getSelectedMaterial, selectKeyboardMultiSelectedItems, setKeyboardMultiSelectedItems } from '../../slices/2D'
import { setHighlightPopupColor } from '../../slices/common'
import { selectActiveGeometryGroup } from '../../slices/geometry'

export function* handleKeyboardSelectedItems() {
    const paperManager: PaperManager | null = yield call(managers.get2DManager)

    if (!paperManager) return

    const multiSelectedItemIds: number[] | null = yield select(selectKeyboardMultiSelectedItems)

    const workspaceTool: Workspace = yield call(paperManager.getTool, Workspace.NAME)

    if (multiSelectedItemIds?.[0]) {
        const item = yield call(workspaceTool.getItemWithPaperId, multiSelectedItemIds[0])

        if (item) {
            if (item?.data?.type === PAPER_ELEMENT_TYPE.HIGHLIGHT) {
                yield put(setHighlightPopupColor(item.fillColor.toCSS(true)))
            }

            const items: paper.Item[] = yield call(
                workspaceTool.getItemsWithCriteria,
                'data',
                (data) => data?.type === item.data.type
            )
            const drawableIds: number[] = items.map((item) => item.data.drawable_id)

            yield call(workspaceTool.lockItems, true, drawableIds)
        }
    } else {
        // the ctrl selection is gone, so restore the lock of the active material group (if any)
        // instead of unlocking the whole canvas
        const activeGroup: ReturnType<typeof selectActiveGeometryGroup> = yield select(selectActiveGeometryGroup)
        const selectedMaterialType: DRAWABLE_TYPES | null = yield select(getSelectedMaterial)

        if (activeGroup?.openings.length && selectedMaterialType !== DRAWABLE_TYPES.RIMBOARD) {
            yield call(
                workspaceTool.lockItems,
                true,
                activeGroup.openings.map((opening) => opening.id)
            )
        } else {
            yield call(workspaceTool.lockItems, false)
        }
    }
}

export function* watchForHandleKeyboardSelectedItems() {
    yield takeLatest(setKeyboardMultiSelectedItems.type, handleKeyboardSelectedItems)
}
